import { FC } from 'react';

import { IPersonalDiagnostic } from 'api/types';
import { DiagnosticCard, DiagnosticCardResultShort } from 'portfolio3/features/diagnostics/components';
import { accentColors } from 'portfolio3/styles';
import { formatDate, getDiagnosticPercentColor } from 'utils';

interface IPersonalDiagnosticCardProps {
  diagnostic: IPersonalDiagnostic;
}

const PersonalDiagnosticCard: FC<IPersonalDiagnosticCardProps> = ({ diagnostic }) => {
  const { percentResult, resultValue, name, subject, eventDate } = diagnostic;

  const date = formatDate(eventDate);

  const percentColor = getDiagnosticPercentColor(percentResult, [
    accentColors.red[80],
    accentColors.orange[80],
    accentColors.yellow[80],
    accentColors.green[80],
  ]);

  const resultElement = (
    <DiagnosticCardResultShort score={resultValue} scorePercent={percentResult} color={percentColor} />
  );

  return <DiagnosticCard title={name} subtitle={subject} date={date} resultElement={resultElement} />;
};

export default PersonalDiagnosticCard;
